import { useMutation, useQuery, useQueryClient, type UseMutationResult, type UseQueryResult } from '@tanstack/react-query'
import type { VenueSourcesDto } from '@lib/dto/venue-sources.dto'
import type { PutVenueSourcesInput } from '@lib/input/venue-sources.input'
import { sourcesService } from '@/services/SourcesService'
import { adsKeys, pipelineKeys, sourcesKeys } from './queryKeys'

/** Where a venue's couples come from: its listing sites and lead source names. */
export function useVenueSources(venueId: string): UseQueryResult<VenueSourcesDto> {
  return useQuery({
    queryKey: sourcesKeys.venue(venueId),
    queryFn: () => sourcesService.venue(venueId),
    enabled: venueId !== '',
    retry: false,
  })
}

/** Saves them whole. The venue's numbers by source are read again, since every period moves at once. */
export function useSaveVenueSources(venueId: string): UseMutationResult<VenueSourcesDto, Error, PutVenueSourcesInput> {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: PutVenueSourcesInput) => sourcesService.saveVenue(venueId, input),
    onSuccess: (saved) => {
      queryClient.setQueryData(sourcesKeys.venue(venueId), saved)
      void queryClient.invalidateQueries({ queryKey: pipelineKeys.venue(venueId) })
      void queryClient.invalidateQueries({ queryKey: adsKeys.venue(venueId) })
    },
  })
}
